import { isNil } from 'lodash';

function formatBytes(value, options) {
  const { decimalPlaces = 2 } = options || {};

  if (!+value) {
    return '0 Bytes';
  }
  const k = 1024;
  const dm = decimalPlaces < 0 ? 0 : decimalPlaces;
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  const i = Math.floor(Math.log(value) / Math.log(k));
  // eslint-disable-next-line stylistic/no-mixed-operators
  return `${parseFloat((value / k ** i).toFixed(dm))} ${sizes[i]}`;
}

function formatNumber(value, options) {
  const { locale = 'en-US', ...restOptions } = options;
  return new Intl.NumberFormat(locale, restOptions).format(value);
}

function formatDecimal(value, options) {
  return formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2, ...options });
}

function formatCurrency(value, options) {
  return formatNumber(value, { currency: 'USD', ...options, style: 'currency' });
}

function formatPrice(value, options) {
  const { currency = 'USD' } = options;

  if (isNil(currency)) {
    return formatDecimal(value);
  }

  try {
    return formatCurrency(value, { currency, ...options });
  }
  catch {
    return formatDecimal(value);
  }
}


export { formatBytes, formatCurrency, formatDecimal, formatNumber, formatPrice };
